/**
 * SubscriptionService
 * Service for fetching and searching subscriptions
 *
 * Architecture:
 * UseCase (Remapper) → SubscriptionService → FirestoreService
 */

import { firestoreService } from '@/data/services/firestoreService';
import type { JsonObject, PageCursor } from '@/data/types/json';

export class SubscriptionService {
  private static instance: SubscriptionService;

  private constructor() {}

  static getInstance(): SubscriptionService {
    if (!this.instance) {
      this.instance = new SubscriptionService();
    }
    return this.instance;
  }

  /**
   * Fetch subscriptions with pagination
   * Returns raw JsonObject items for remapping in use case
   */
  async getExclusiveContentSubscriptions(
    currentUserId: string,
    cursor?: PageCursor,
    limitCount: number = 20,
    meSubscriber?: boolean | null
  ): Promise<{
    items: JsonObject[];
    hasMore: boolean;
    cursor?: PageCursor;
  }> {
    console.log('[SubscriptionService] Fetching subscriptions:', {
      currentUserId,
      limitCount,
      meSubscriber,
      hasCursor: !!cursor,
    });

    const result = await firestoreService.getExclusiveContentSubscriptions(
      currentUserId,
      cursor,
      limitCount,
      meSubscriber
    );

    console.log('[SubscriptionService] Fetched subscriptions:', result.items.length);

    return result;
  }

  /**
   * Search subscriptions by keyword
   * Returns raw JsonObject items for remapping in use case
   */
  async searchSubscriptions(
    currentUserId: string,
    keyword: string,
    cursor?: PageCursor,
    limitCount: number = 20,
    searchLastName: boolean = false
  ): Promise<{
    items: JsonObject[];
    hasMore: boolean;
    cursor?: PageCursor;
  }> {
    console.log('[SubscriptionService] Searching subscriptions:', {
      currentUserId,
      keyword,
      searchLastName,
    });

    const result = await firestoreService.searchSubscriptions(
      currentUserId,
      keyword,
      cursor,
      limitCount,
      searchLastName
    );

    console.log('[SubscriptionService] Search results:', result.items.length);

    return result;
  }
}

// Export singleton instance for convenience
export const subscriptionService = SubscriptionService.getInstance();
